import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import WoocommerceAPI from '../../IPSAPI/WoocommerceAPI';
import PlusIcon from '../../assets/svg/PlusIcon';
import MinusIcon from '../../assets/svg/MinusIcon';
import { RootState } from '../../../redux/checkoutredux/store/checkoutStore';
import { setAllCartData } from '../../../redux/checkoutredux/actions/cartactions/fetchdirectActions';

interface ContentElStepperProps {
  productId: string;
  keyId: string;
  quantity: number;
  deleteandfetchData: (keyId: string) => void;
  setCurrentProductId: React.Dispatch<React.SetStateAction<string[]>>;
  currentCartKeyId: string[];
  setCurrentCartKeyId: React.Dispatch<React.SetStateAction<string[]>>;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  orderbumpupdate?: boolean;
}

const ContentElStepper: React.FC<ContentElStepperProps> = ({
  productId,
  keyId,
  quantity: initialQuantity,
  deleteandfetchData,
  setCurrentProductId,
  currentCartKeyId,
  setCurrentCartKeyId,
  setLoading,
  orderbumpupdate,
}) => {
  const settings = useSelector((state: RootState) => state.sidecartsettings.appSettings || null);
  const [quantityinner, setQuantityinner] = useState<number>(initialQuantity || 1);
  const [stepperchange, setStepperChange] = useState(1);
  const [stepperchangemax] = useState(1); // Setting for when skeleton appears
  const [originalQuantity, setOriginalQuantity] = useState<number>(initialQuantity);
  const [isEditing, setIsEditing] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    setQuantityinner(initialQuantity);
    setOriginalQuantity(initialQuantity);
  }, [initialQuantity]);

  useEffect(() => {
    if (stepperchange > stepperchangemax) {
      setLoading(true);
      setStepperChange((prev) => prev + 1);
    }
  }, [stepperchange, stepperchangemax, setLoading]);

  const handleQuantityClick = () => {
    setIsEditing(true);
  };

  const handleQuantityChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newQuantity = parseInt(event.target.value, 10);
    setQuantityinner(newQuantity);
    setCurrentProductId((prev) => [...prev, productId]);
    setCurrentCartKeyId([keyId]);
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      setIsEditing(false);
      const newQuantity = parseInt(event.currentTarget.value, 10);
      if (!isNaN(newQuantity)) {
        updateCartQuantity(newQuantity);
      }
    }
  };

  const handleBlur = () => {
    setIsEditing(false);
    setQuantityinner(originalQuantity);
  };

  const increaseQuantity = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setCurrentProductId((prev) => [...prev, productId]);
    setCurrentCartKeyId([keyId]);
    setQuantityinner((prevQuantity) => {
      const newQuantity = prevQuantity + 1;
      updateCartQuantity(newQuantity);
      return newQuantity;
    });
  };

  const decreaseQuantity = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setCurrentProductId((prev) => [...prev, productId]);
    setCurrentCartKeyId([keyId]);
    if (quantityinner > 1) {
      setQuantityinner((prevQuantity) => {
        const newQuantity = prevQuantity - 1;
        updateCartQuantity(newQuantity);
        return newQuantity;
      });
    } else {
      deleteandfetchData(keyId);
    }
  };

  const updateCartQuantity = async (newQuantity: number) => {
    try {
      setStepperChange((prev) => prev + 1);
      const response = await WoocommerceAPI.ipsajax_updateCartItemQuantity(
        settings.base_url,
        productId,
        keyId,
        newQuantity
      );
      setLoading(false);
      dispatch(setAllCartData(response.data));
    } catch (error) {
      console.error('Error updating cart quantity:', error);
    }
  };

  return (
    <div className="content-element">
      <div className="ips-edit-quantity-control-wrap">
        <div className="ips-quantity-stepper">
          <button
            onClick={decreaseQuantity}
            aria-label="Decrease"
            className="ips-stepper-btn-minus"
          >
            <MinusIcon />
          </button>
          {isEditing ? (
            <input
              type="number"
              value={quantityinner}
              onBlur={handleBlur}
              onChange={handleQuantityChange}
              onKeyDown={handleKeyPress}
              autoFocus
              className="ips-input-no-arrows"
            />
          ) : (
            <a
              onClick={handleQuantityClick}
              className="ips-stepper-value-label ips-bulk-edit"
              aria-label="Edit"
            >
              {quantityinner}
            </a>
          )}
          <button
            onClick={orderbumpupdate ? increaseQuantity : undefined}
            aria-label="Increase"
            className={`ips-stepper-btn-plus ${orderbumpupdate ? '' : 'maxed'}`}
          >
            <PlusIcon />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContentElStepper;